var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('iframe',{style:({
    display: 'block',
    border: 'none',
    position: 'absolute',
    width: '100%',
    height: 'calc(100dvh - var(--nav-height) - 48px)'
  }),attrs:{"sandbox":"allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads","allowfullscreen":"true","src":_vm.src}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b298566","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/dashboard/customize/amaze/DashboardAmazeConversationIframe.vue
// module id = null
// module chunks = 